import { useState, useRef, useEffect } from 'react';

export const useMessageState = () => {
  const [messages, setMessages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingChat, setIsLoadingChat] = useState(false);
  const [error, setError] = useState(null);
  const [typingMessage, setTypingMessage] = useState('');
  const messagesRef = useRef([]);
  const sendingMessage = useRef(false);
  const sseStreamingActive = useRef(false);

  // Keep messages ref in sync
  useEffect(() => {
    messagesRef.current = Array.isArray(messages) ? messages : [];
  }, [messages]);

  const clearMessages = () => {
    setMessages([]);
    setIsLoading(false);
    setError(null);
  };

  const addMessage = (message) => {
    setMessages(prev => {
      const currentMessages = Array.isArray(prev) ? prev : [];
      return [...currentMessages, message];
    });
  };

  const updateMessage = (messageId, updates) => {
    setMessages(prev => prev.map(msg => 
      msg._id === messageId ? { ...msg, ...updates } : msg
    ));
  };

  const replaceTemporaryMessage = (predicate, newMessage) => {
    setMessages(prev => {
      const currentMessages = Array.isArray(prev) ? prev : [];
      const index = currentMessages.findIndex(predicate);
      if (index !== -1) {
        const newMessages = [...currentMessages];
        newMessages[index] = { ...newMessages[index], ...newMessage };
        return newMessages;
      }
      return [...currentMessages, newMessage];
    });
  };

  return {
    messages,
    setMessages,
    isLoading,
    setIsLoading,
    isLoadingChat,
    setIsLoadingChat,
    error,
    setError,
    typingMessage,
    setTypingMessage,
    messagesRef,
    sendingMessage,
    sseStreamingActive,
    clearMessages,
    addMessage,
    updateMessage,
    replaceTemporaryMessage
  };
}; 